import React, { useEffect, useState } from "react";
import moment from "moment";
import "moment/locale/vi";
import classNames from "classnames";
import { IoIosArrowBack } from "react-icons/io";
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowUp } from "react-icons/io";
import { MdKeyboardDoubleArrowLeft } from "react-icons/md";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";

function AppointmentCalendar({ value, onselect, setTopHeight }) {
  const [dateList, setDateList] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [currentMonth, setCurrentMonth] = useState("");
  const [currentMonthToShow, setCurrentMonthToShow] = useState("");
  const [selectedCurrentWeek, setSelectedCurrentWeek] = useState("");
  const [isExpandedCalender, setIsExpandedCalender] = useState(false);
  const [viewHeight, setViewHeight] = useState(570);

  useEffect(() => {
    let newDate = selectedDate;
    if (value != null) {
      newDate = value;
      setSelectedDate(value);
    }
    setMonth(newDate);
    setWeek(newDate);
  }, [value, isExpandedCalender]);

  useEffect(() => {
    setTopHeight(viewHeight);
  }, [viewHeight]);

  function setWeek(date, isExpandedCalenderValue) {
    let dateList = [];
    if (isExpandedCalender || isExpandedCalenderValue) {
      let startMonthDate = moment(date).startOf("month");
      let startWeek = moment(startMonthDate).startOf("week");
      let endMonthDate = moment(date).endOf("month");
      let endWeek = moment(endMonthDate).endOf("week");
      dateList = getDateList(startWeek, endWeek);
    } else {
      let startWeek = moment(date).startOf("week");
      let endWeek = moment(date).endOf("week");
      dateList = getDateList(startWeek, endWeek);
    }
    setSelectedCurrentWeek(moment(date).endOf("week"));
    let splitDataList = splitData(dateList);
    setDateList(splitDataList);
    let h = 6.4;
    for (let i = 0; i < splitDataList.length; i++) {
      if (i == 0) {
        h = h + 3.2;
      } else {
        h = h + 2.3;
      }
    }
    setViewHeight(h);
  }

  const getDateList = (startDate, stopDate) => {
    var dateArray = [];
    var currentDate = moment(startDate);
    var stopDate = moment(stopDate);
    while (currentDate <= stopDate) {
      dateArray.push(moment(currentDate).format("YYYY-MM-DD"));
      currentDate = moment(currentDate).add(1, "days");
    }
    return dateArray;
  };

  function setMonth(date) {
    if (date != null && date != "") {
      let month = moment(date).format("MMMM YYYY");
      if (month != undefined) {
        setCurrentMonthToShow(month);
        setCurrentMonth(new Date(date));
      }
    }
  }

  function changeWeek(type) {
    let date = moment(selectedCurrentWeek).add(type == "NEXT" ? 7 : -7, "days");
    setWeek(date);
    setMonth(date);
    setSelectedCurrentWeek(date);
  }

  function changeMonth(type) {
    const startOfNextMonth = moment(currentMonth)
      .add(type == "NEXT" ? 1 : -1, "M")
      .startOf("month");

    if (moment(selectedDate).format("YYYY-MM") === moment(startOfNextMonth).format("YYYY-MM")) {
      setWeek(moment(selectedDate).format("YYYY-MM-DD"));
    } else if (moment(startOfNextMonth).format("YYYY-MM") === moment(new Date()).format("YYYY-MM")) {
      setWeek(moment(new Date()).format("YYYY-MM-DD"));
    } else {
      setWeek(startOfNextMonth);
    }
    setMonth(startOfNextMonth);
  }

  function splitData(dateList) {
    let arr = [];
    const chunkSize = 7;
    for (let i = 0; i < dateList.length; i += chunkSize) {
      const chunk = dateList.slice(i, i + chunkSize);
      arr.push(chunk);
    }
    return arr;
  }
    const [selectedLang, setSelectedLang] = useState("en-US");
  
    useEffect(() => {
      const savedLanguage = localStorage.getItem("i18nextLng") || "en";
      const lang = savedLanguage.startsWith("vi") ? "vi" : "en";
      setSelectedLang(lang);
      moment.locale(lang); // Set moment locale immediately
    }, []);

    useEffect(() => {
      moment.locale(selectedLang);
      if (currentMonth) {
        setMonth(currentMonth);
      }
    }, [selectedLang]);

  function renderDateList(item, i, parentIndex) {
    let selectedDateValue = moment(selectedDate).format("YYYY-MM-DD") === moment(item).format("YYYY-MM-DD");

    let isCurrDate = moment(new Date()).format("YYYY-MM-DD") === moment(item).format("YYYY-MM-DD");

    let isGrayedOut;
    if (moment(item).startOf("month").format("YYYY-MM") !== moment(selectedDate).startOf("month").format("YYYY-MM")) {
      isGrayedOut = true;
    }
    let weekDay = moment(item).format("ddd");

    return (
      <div className="justify-center">
        {parentIndex === 0 ? <div className="text-black font-bold  flex font-sans justify-center">{weekDay}</div> : null}
        <div className="flex justify-center">
          <div
            className={classNames(
              "rounded-[50%] text-black font-sans  h-[2rem] w-[2rem] text-lg px-[1rem] pt-[0rem] pb-[1.2rem] align-center cursor-pointer font-light mt-[5px] flex justify-center  md:hover:bg-green-400 md:hover:rounded-[50%] md:hover:h-[2rem] md:hover:w-[2rem]  md:hover:px-[1rem] md:hover:pt-[0rem] md:hover:pb-[1.2rem] md:hover:align-center md:hover:cursor-pointer",
              selectedDateValue ? "h-[2rem] w-[2rem] bg-main text-white rounded-[50%] flex  px-[1rem] pt-[0rem] pb-[1.2rem] align-center cursor-pointer" : "week-unselected-value",
              isCurrDate ? "rounded-[50%] border-main border h-[2rem] w-[2rem] flex  px-[1rem] pt-[0rem] pb-[1.2rem] align-center cursor-pointer" : "",
              isGrayedOut ? "text-gray-400 " : "",
            )}
            onClick={() => {
              setSelectedDate(item);
              setMonth(item);
              onselect(item);
            }}
          >
            {moment(item).format("DD")}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className="rounded-md transition-all overflow-hidden p-[15px] w-full shadow-primaryshadow"
      style={{
        height: viewHeight + "rem",
      }}
    >
      <div className="flex justify-between items-center">
        <div>
          {isExpandedCalender ? null : (
            <div onClick={() => changeWeek("PREVIOUS")} title={"Previous Week"}>
              <MdKeyboardDoubleArrowLeft className="text-main cursor-pointer md:hover:bg-green-200 md:hover:rounded-[50%] text-2xl" />
              {/*<img
                src={leftArrow}
                className="cursor-pointer bg-transparent text-main rounded-full transition duration-300 font-normal  p-1 w-[24px] mt-[-8px]"
              />*/}
            </div>
          )}
        </div>
        <div className="flex justify-between items-center">
          <div
            onClick={() => {
              changeMonth("PREVIOUS");
            }}
            title={"Previous Month"}
          >
            <IoIosArrowBack className="text-main cursor-pointer  md:hover:bg-green-200 md:hover:rounded-[50%] text-xl" />
          </div>
          <span className="text-center w-36 text-black font-light font-sans mx-2">{currentMonthToShow}</span>
          <div
            className="rotate-180 h-[22px]"
            onClick={() => {
              changeMonth("NEXT");
            }}
            title={"Next Month"}
          >
            <IoIosArrowBack className="text-main cursor-pointer  md:hover:bg-green-200 md:hover:rounded-[50%] text-xl" />
          </div>
        </div>
        <div>
          {isExpandedCalender ? null : (
            <div onClick={() => changeWeek("NEXT")} title={"Next Week"}>
              <MdKeyboardDoubleArrowRight className="text-main cursor-pointer  md:hover:bg-green-200 md:hover:rounded-[50%] text-2xl" />
              {/*<img
                src={rightArrow}
                className="cursor-pointer text-main rounded-full transition duration-300 px-[4px]  w-[24px] mt-[-8px]"
              />*/}
            </div>
          )}
        </div>
      </div>
      <table className="w-[100%] mt-[0.5rem]">
        <tbody>
          {dateList.map((row, index) => (
            <tr key={row[0]}>
              {row.map((cellId, i) => (
                <th key={cellId}> {renderDateList(cellId, i, index)} </th>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      <div className="flex  justify-center">
        {isExpandedCalender ? (
          <div
            onClick={() => {
              setIsExpandedCalender(false);
              setWeek();
            }}
            className="mt-2"
            title={"Collapse"}
          >
            <IoIosArrowUp className="text-main cursor-pointer  md:hover:bg-green-200 md:hover:rounded-[50%] text-xl" />
          </div>
        ) : (
          <div
            onClick={() => {
              setIsExpandedCalender(true);
              setWeek(currentMonth, true);
            }}
            className="mt-2"
            title={"Full View"}
          >
            <IoIosArrowDown className="text-main cursor-pointer  md:hover:bg-green-200 md:hover:rounded-[50%] text-xl" />
          </div>
        )}
      </div>
    </div>
  );
}

export default AppointmentCalendar;
